import { render, staticRenderFns } from "./BirthdaysBirthdayDetails.vue?vue&type=template&id=324a34c2&scoped=true&"
import script from "./BirthdaysBirthdayDetails.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysBirthdayDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a34c2",
  null
  
)

export default component.exports